/* Snoozie collection page: filters built from product tags, sort, active chips, shareable URL.
   Products are rendered by Liquid (SEO); this script only shows, hides and reorders them. */
(function () {
  'use strict';
  var root = document.querySelector('[data-snc]');
  if (!root) return;

  var FR = root.getAttribute('data-locale') === 'fr';
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
  var grid = root.querySelector('[data-grid]');
  var facetsEl = root.querySelector('[data-facets]');
  var chosenEl = root.querySelector('[data-chosen]');
  var countEl = root.querySelector('[data-count]');
  var emptyEl = root.querySelector('[data-empty]');
  var sortEl = root.querySelector('[data-sort]');
  var minEl = root.querySelector('[data-min]');
  var maxEl = root.querySelector('[data-max]');
  var stockEl = root.querySelector('[data-stock]');
  var badgeEl = root.querySelector('[data-badge]');
  var total = cards.length;

  /* ---- vocabulary (tag prefix -> facet) ---- */
  var FACETS = [
    { key: 'cat', param: 'for', title: FR ? 'Pour' : 'For', open: true },
    { key: 'type', param: 'shape', title: FR ? 'Forme' : 'Shape', open: true },
    { key: 'size', param: 'size', title: FR ? 'Taille' : 'Size', open: true },
    { key: 'color', param: 'color', title: FR ? 'Couleur' : 'Color', open: false },
    { key: 'mat', param: 'material', title: FR ? 'Matière' : 'Material', open: false }
  ];
  var LABEL = {
    cat: { 'dog-beds': ['Dogs', 'Chiens'], 'cat-beds': ['Cats', 'Chats'], 'pet-beds': ['Cats and dogs', 'Chats et chiens'] },
    type: { 'flat-bed': ['Flat beds', 'Lits plats'], 'donut-bed': ['Donut beds', 'Lits ronds'], 'cave-bed': ['Cave beds', 'Lits caverne'], 'sofa-bed': ['Sofa beds', 'Lits canapé'], 'sleeping-bag': ['Sleeping bag beds', 'Lits sac de couchage'], 'nest-bed': ['Nests', 'Nids'], 'oval-bed': ['Oval beds', 'Lits ovales'], 'cushion-mat': ['Cushions and mats', 'Coussins et tapis'] },
    size: { small: ['Small', 'Petit'], medium: ['Medium', 'Moyen'], large: ['Large', 'Grand'], 'extra-large': ['Extra large', 'Très grand'] },
    mat: { plush: ['Plush', 'Peluche'], cotton: ['Cotton', 'Coton'], polyester: ['Polyester', 'Polyester'] },
    color: { grey: ['Grey', 'Gris'], gray: ['Grey', 'Gris'], beige: ['Beige', 'Beige'], blue: ['Blue', 'Bleu'], 'navy-blue': ['Navy blue', 'Bleu marine'], green: ['Green', 'Vert'], brown: ['Brown', 'Brun'], black: ['Black', 'Noir'], white: ['White', 'Blanc'], cream: ['Cream', 'Crème'], pink: ['Pink', 'Rose'], red: ['Red', 'Rouge'], yellow: ['Yellow', 'Jaune'], orange: ['Orange', 'Orange'], purple: ['Purple', 'Mauve'], khaki: ['Khaki', 'Kaki'], coffee: ['Coffee', 'Café'] }
  };
  var DOT = { grey: '#9aa0a6', gray: '#9aa0a6', beige: '#d8c3a5', blue: '#5b86c7', 'navy-blue': '#1e2a4a', green: '#6f9a6b', brown: '#7a5a3c', black: '#1b1b1b', white: '#ffffff', cream: '#fff6e3', pink: '#f0a5b8', red: '#d64545', yellow: '#f0cf58', orange: '#ec8a3c', purple: '#8e6bbf', khaki: '#b5a96a', coffee: '#6b4a34' };
  var SIZE_ORDER = ['small', 'medium', 'large', 'extra-large'];

  function pretty(slug) { return slug.replace(/-/g, ' ').replace(/^./, function (c) { return c.toUpperCase(); }); }
  function label(key, slug) { var l = LABEL[key] && LABEL[key][slug]; return l ? l[FR ? 1 : 0] : pretty(slug); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---- read product data ---- */
  var data = cards.map(function (el, i) {
    var tags = (el.getAttribute('data-tags') || '').split(',').map(function (t) { return t.trim(); });
    var by = {};
    tags.forEach(function (t) {
      var ix = t.indexOf(':'); if (ix < 1) return;
      var k = t.slice(0, ix), v = t.slice(ix + 1);
      (by[k] = by[k] || []).push(v);
    });
    return { el: el, by: by, price: parseFloat(el.getAttribute('data-price')) || 0, avail: el.getAttribute('data-available') === 'true',
      created: parseInt(el.getAttribute('data-created'), 10) || 0, name: el.getAttribute('data-name') || '', pos: i };
  });

  /* ---- facet values (only those that really exist) ---- */
  var facets = FACETS.map(function (f) {
    var set = {};
    data.forEach(function (d) { (d.by[f.key] || []).forEach(function (v) { set[v] = true; }); });
    var vals = Object.keys(set);
    if (f.key === 'size') vals.sort(function (a, b) { return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b); });
    else vals.sort(function (a, b) { return label(f.key, a).localeCompare(label(f.key, b)); });
    return { cfg: f, values: vals };
  }).filter(function (f) { return f.values.length > 1; });   // a facet with one value filters nothing

  var state = { sel: {}, stock: false, min: '', max: '', sort: 'featured' };
  facets.forEach(function (f) { state.sel[f.cfg.key] = {}; });

  /* ---- URL <-> state ---- */
  function readUrl() {
    var q = new URLSearchParams(location.search);
    facets.forEach(function (f) {
      (q.get(f.cfg.param) || '').split(',').filter(Boolean).forEach(function (v) { if (f.values.indexOf(v) > -1) state.sel[f.cfg.key][v] = true; });
    });
    state.stock = q.get('stock') === '1';
    state.min = q.get('min') || ''; state.max = q.get('max') || '';
    var s = q.get('sort'); if (s && sortEl.querySelector('option[value="' + s + '"]')) state.sort = s;
  }
  function writeUrl() {
    var q = new URLSearchParams(location.search);
    ['for', 'shape', 'size', 'color', 'material', 'stock', 'min', 'max', 'sort', 'page'].forEach(function (k) { q.delete(k); });
    facets.forEach(function (f) { var v = Object.keys(state.sel[f.cfg.key]); if (v.length) q.set(f.cfg.param, v.join(',')); });
    if (state.stock) q.set('stock', '1');
    if (state.min !== '') q.set('min', state.min);
    if (state.max !== '') q.set('max', state.max);
    if (state.sort !== 'featured') q.set('sort', state.sort);
    var qs = q.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }

  /* ---- matching ---- */
  function matches(d, skip) {
    for (var i = 0; i < facets.length; i++) {
      var k = facets[i].cfg.key; if (k === skip) continue;
      var chosen = Object.keys(state.sel[k]); if (!chosen.length) continue;
      var have = d.by[k] || [];
      if (!chosen.some(function (v) { return have.indexOf(v) > -1; })) return false;
    }
    if (state.stock && !d.avail) return false;
    if (state.min !== '' && d.price < parseFloat(state.min)) return false;
    if (state.max !== '' && d.price > parseFloat(state.max)) return false;
    return true;
  }

  /* ---- build filter UI once ---- */
  function buildFacets() {
    facetsEl.innerHTML = facets.map(function (f) {
      var k = f.cfg.key;
      return '<div class="snc__group"><details' + (f.cfg.open ? ' open' : '') + '><summary>' + esc(f.cfg.title) + '</summary><ul class="snc__options">' +
        f.values.map(function (v) {
          var dot = k === 'color' ? '<span class="snc__dot" style="background:' + (DOT[v] || '#ccc') + '"></span>' : '';
          return '<li><label class="snc__opt" data-opt="' + k + ':' + v + '"><input type="checkbox" data-facet="' + k + '" value="' + esc(v) + '">' + dot + '<span>' + esc(label(k, v)) + '</span><em data-n></em></label></li>';
        }).join('') + '</ul></details></div>';
    }).join('');
  }

  /* ---- render ---- */
  function render() {
    var visible = data.filter(function (d) { return matches(d); });
    data.forEach(function (d) { d.el.hidden = visible.indexOf(d) === -1; });

    var sorted = visible.slice();
    var s = state.sort;
    sorted.sort(function (a, b) {
      if (s === 'price-asc') return a.price - b.price;
      if (s === 'price-desc') return b.price - a.price;
      if (s === 'newest') return b.created - a.created;
      if (s === 'name') return a.name.localeCompare(b.name);
      if (a.avail !== b.avail) return a.avail ? -1 : 1;     // featured: sold out last
      return a.pos - b.pos;
    });
    sorted.forEach(function (d) { grid.appendChild(d.el); });
    data.filter(function (d) { return visible.indexOf(d) === -1; }).forEach(function (d) { grid.appendChild(d.el); });

    var n = visible.length, filtered = n !== total;
    var noun = FR ? (n === 1 ? 'lit' : 'lits') : (n === 1 ? 'bed' : 'beds');
    countEl.textContent = filtered ? (FR ? n + ' sur ' + total + ' lits' : n + ' of ' + total + ' beds') : (n + ' ' + noun);
    emptyEl.hidden = n !== 0; grid.hidden = n === 0;

    /* faceted counts: for each option, how many products match everything else */
    facets.forEach(function (f) {
      f.values.forEach(function (v) {
        var c = data.filter(function (d) { return matches(d, f.cfg.key) && (d.by[f.cfg.key] || []).indexOf(v) > -1; }).length;
        var opt = facetsEl.querySelector('[data-opt="' + f.cfg.key + ':' + v + '"]');
        if (!opt) return;
        opt.querySelector('[data-n]').textContent = c;
        opt.classList.toggle('is-zero', c === 0 && !state.sel[f.cfg.key][v]);
        opt.querySelector('input').checked = !!state.sel[f.cfg.key][v];
      });
    });
    stockEl.checked = state.stock; minEl.value = state.min; maxEl.value = state.max; sortEl.value = state.sort;

    /* active chips */
    var chips = [];
    facets.forEach(function (f) { Object.keys(state.sel[f.cfg.key]).forEach(function (v) { chips.push({ t: label(f.cfg.key, v), k: f.cfg.key, v: v }); }); });
    if (state.stock) chips.push({ t: FR ? 'En stock' : 'In stock', k: 'stock' });
    if (state.min !== '' || state.max !== '') chips.push({ t: (state.min !== '' ? '$' + state.min : '$0') + ' to ' + (state.max !== '' ? '$' + state.max : '…'), k: 'price' });
    if (FR) chips.forEach(function (c) { c.t = c.t.replace(' to ', ' à '); });
    chosenEl.hidden = chips.length === 0;
    chosenEl.innerHTML = chips.map(function (c) {
      return '<button type="button" class="snc__pill" data-rm="' + c.k + '" data-v="' + esc(c.v || '') + '">' + esc(c.t) + ' <span aria-hidden="true">&times;</span><span class="visually-hidden">' + (FR ? 'Retirer' : 'Remove') + '</span></button>';
    }).join('') + (chips.length > 1 ? '<button type="button" class="snc__clearall" data-clear>' + (FR ? 'Tout effacer' : 'Clear all') + '</button>' : '');
    if (badgeEl) badgeEl.textContent = chips.length ? '(' + chips.length + ')' : '';
    writeUrl();
  }

  /* ---- events ---- */
  function clearAll() { facets.forEach(function (f) { state.sel[f.cfg.key] = {}; }); state.stock = false; state.min = ''; state.max = ''; render(); }
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-facet]')) { var set = state.sel[t.getAttribute('data-facet')]; if (t.checked) set[t.value] = true; else delete set[t.value]; render(); }
    else if (t === stockEl) { state.stock = t.checked; render(); }
    else if (t === sortEl) { state.sort = t.value; render(); }
    else if (t === minEl || t === maxEl) { state[t === minEl ? 'min' : 'max'] = t.value.trim(); render(); }
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-clear')) { clearAll(); return; }
    if (b.hasAttribute('data-rm')) {
      var k = b.getAttribute('data-rm'), v = b.getAttribute('data-v');
      if (k === 'stock') state.stock = false; else if (k === 'price') { state.min = ''; state.max = ''; } else delete state.sel[k][v];
      render(); return;
    }
    if (b.hasAttribute('data-open')) { root.classList.add('is-open'); root.querySelector('[data-scrim]').hidden = false; document.body.style.overflow = 'hidden'; var f = root.querySelector('[data-close]'); if (f) f.focus(); }
    if (b.hasAttribute('data-close') || b.hasAttribute('data-apply')) closePanel();
  });
  function closePanel() { root.classList.remove('is-open'); root.querySelector('[data-scrim]').hidden = true; document.body.style.overflow = ''; var o = root.querySelector('[data-open]'); if (o && getComputedStyle(o).display !== 'none') o.focus(); }
  root.querySelector('[data-scrim]').addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) closePanel(); });

  buildFacets(); readUrl(); render();
  if (!facets.length) { var pn = root.querySelector('[data-panel]'); if (pn) { /* only price + stock remain */ } }
})();
